<template>
  <div>
    <transition>
      <div class="logout flexcenter">
        <div class="logout-dialog flexcenter">
          <div class="lbold font18">ログアウトします。よろしいですか？</div>
          <div class="flexcenter buttons">
            <button class="nobutton font14" type=button v-on:click="clickButton(false)"><span class="notext">いいえ</span></button>
            <button class="yesbutton font14" type=button v-on:click="clickButton(true)"><span class="yestext">はい</span></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'
import http from '@/mixin/http'

export default {
  name: 'logout',
  props: {
    productInfo: Object
  },
  mixins: [
    common,
    http
  ],
  methods: {
    clickButton: function(flag) {
      this.log("Logout start clickButton: " + flag)

      if(flag) {
        this.doLogout()
      } else {
          this.$emit('closeLogout')
      }
    },
    /**
     * ログアウトAPI呼び出し
     */
    doLogout: function() {
      this.log("Logout start doLogout")
      var self = this

      // ログアウトAPIを実行
      this.logout()
      .then(function(response) {
        self.log("Logout doLogout resultCode: " + response.result_code)
        self.goLogin()
      })
      .catch(function(err) {
        self.goLogin()
      })
    },
    /**
     * ログイン画面へ遷移
     */
    goLogin: function() {
      window.location.replace(this.makeLoginURL())
    },
    /**
     * ログイン画面のURLを作成する
     */
    makeLoginURL: function() {
      var contentID = this.productInfo.code
      var url = process.env.LIBRARY_URL + "login"
      return url
    }
  },
  mounted: function() {
    this.log("Logout start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Logout.vue?30a1f108